import moment from "moment";

import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  vehicleOnBoardingSteps: {},
  vendorsDetail: { loading: false, vendors: [] },
  vehicleFormData: {
    supplier: {},
    carRelatedDetails: {},
    paymentDetails: {},
    freightCharges: {},
    sellerInvoice: {}
  },
  Url: {
    taxUrl: [],
    frieghtUrl: [],
    proformaUrl: []
  },
  appointmentId: null,
  stockId: null,
  variantsDetail: {
    loading: false,
    variants: [],
    availableFilters: {},
    currentFilters: {},
    selectedVariant: null
  },
  submitFormStatus: {
    loading: false,
    error: null,
    leadId: null
  }
};

const setVehicleOnBoardingSteps = (state, action) => ({ ...state, vehicleOnBoardingSteps: action.data });

const setVehicleFormData = (state, action) => {
  if (action.data?.supplierData) {
    return {
      ...state,
      vehicleFormData: {
        ...state.vehicleFormData,
        supplier: action.data.supplierData
      }
    };
  }
  const val = action.data;

  return {
    ...state,
    vehicleFormData: {
      ...state.vehicleFormData,
      ...val
    }
  };
};

const fetchVariantsStart = (state, action) => ({
  ...state,
  variantsDetail: {
    ...state.variantsDetail,
    loading: true
  }
});
const fetchVariantsSuccess = (state, action) => ({
  ...state,
  variantsDetail: {
    ...state.variantsDetail,
    loading: false,
    variants: action.data
  }
});
const fetchVariantsFail = (state, action) => ({
  ...state,
  variantsDetail: {
    ...state.variantsDetail,
    loading: false
  }
});

const setAvailableFilters = (state, action) => ({
  ...state,
  variantsDetail: {
    ...state.variantsDetail,
    availableFilters: action.data
  }
});

const setCurrentFilter = (state, action) => ({
  ...state,
  variantsDetail: {
    ...state.variantsDetail,
    currentFilters: action.data
  }
});

const setSelectedVariant = (state, action) => ({
  ...state,
  variantsDetail: {
    ...state.variantsDetail,
    selectedVariant: action.data
  }
});

const resetVehicleFormData = (state, action) => ({
  ...state,
  vehicleOnBoardingSteps: {},
  vehicleFormData: {
    supplier: {},
    carRelatedDetails: {},
    paymentDetails: {},
    freightCharges: {},
    sellerInvoice: {}
  },
  variantsDetail: {
    variants: [],
    availableFilters: {},
    currentFilters: {},
    selectedVariant: null
  },
  Url: {
    tax: [],
    freight: [],
    proforma: []
  },
  appointmentId: null,
  stockId: null
});

const getVehicleDataStart = (state, action) => ({
  ...state,
  loading: true
});

const getVehicleDataSuccess = (state, action) => {
  const { ...otherValues } = action.data.invoiceDetails;
  let submitLinkStartPoint = "";
  const taxUrl = [];
  const freightUrl = [];
  const proformaUrl = [];

  let freightPdf = [];
  let proformaPdf = [];
  let taxPdf = [];

  action.data.invoices.freightInvoice !== null &&
    action.data.invoices?.freightInvoice.forEach((item, index) => {
      if (item.submitVia) {
        if (submitLinkStartPoint === "") {
          submitLinkStartPoint = index;
        }
        freightUrl.push(item);
      }
    });

  if (submitLinkStartPoint !== "") {
    freightPdf = action.data.invoices?.freightInvoice.slice(0, submitLinkStartPoint);
  } else {
    freightPdf = action.data.invoices?.freightInvoice;
  }

  submitLinkStartPoint = "";

  action.data.invoices.proformaInvoice !== null &&
    action.data.invoices?.proformaInvoice.forEach((item, index) => {
      if (item.submitVia) {
        if (submitLinkStartPoint === "") {
          submitLinkStartPoint = index;
        }
        proformaUrl.push(item);
      }
    });

  if (submitLinkStartPoint !== "") {
    proformaPdf = action.data.invoices?.proformaInvoice.slice(0, submitLinkStartPoint);
  } else {
    proformaPdf = action.data.invoices?.proformaInvoice;
  }

  submitLinkStartPoint = "";

  action.data.invoices.taxInvoice !== null &&
    action.data.invoices?.taxInvoice.forEach((item, index) => {
      if (item.submitVia) {
        if (submitLinkStartPoint === "") {
          submitLinkStartPoint = index;
        }
        taxUrl.push(item);
      }
    });

  if (submitLinkStartPoint !== "") {
    taxPdf = action.data.invoices?.taxInvoice.slice(0, submitLinkStartPoint);
  } else {
    taxPdf = action.data.invoices?.taxInvoice;
  }

  const { freightChargesExclGST, gstOnFreightCharges, fuelCharges, freightInvoice, ...other } =
    action.data.paymentDetails;

  const supplier = {
    ...otherValues,
    source: action.data.source,
    saleChannel: action.data?.saleChannel,
    taxInvoiceDate: otherValues.taxInvoiceDate ? new moment(otherValues.taxInvoiceDate) : null,
    proformaInvoiceData: otherValues.proformaInvoiceData ? new moment(otherValues.proformaInvoiceData) : null,
    sourceType: action.data.sourceType
  };
  const carRelatedDetails = {
    ...action.data.vehicleDetails,
    regExpired: action.data.vehicleDetails.regExpired ? new moment(action.data.vehicleDetails.regExpired) : null,
    complianceDate: action.data.vehicleDetails.complianceDate
      ? new moment(action.data.vehicleDetails.complianceDate)
      : null
  };
  const paymentDetails = other;
  const freightCharges = {
    freightChargesExclGST,
    gstOnFreightCharges,
    fuelCharges
  };

  return {
    ...state,
    loading: false,
    vehicleFormData: {
      supplier,
      carRelatedDetails,
      paymentDetails,
      freightCharges,
      sellerInvoice: {
        freightInvoice: freightPdf,
        proformaInvoice: proformaPdf,
        taxInvoice: taxPdf
      }
    },
    variantsDetail:
      action.data.vehicleDetails.variantDetails !== null
        ? {
            selectedVariant: {
              variant: action.data.vehicleDetails.variantDetails,
              variantViewModel: {
                highlightedText: action.data.vehicleDetails.variantDetails.highlightedText
              }
            }
          }
        : {},
    Url: {
      tax: taxUrl,
      freight: freightUrl,
      proforma: proformaUrl
    }
  };
};
const getVehicleDataFail = (state, action) => ({
  ...state,
  loading: false
});

const submitFormStart = (state, action) => ({
  ...state,
  submitFormStatus: {
    loading: true,
    error: null
  }
});
const submitFormSuccess = (state, action) => ({
  ...state,
  submitFormStatus: {
    loading: false,
    error: null,
    leadId: action.data.leadId
  }
});
const submitFormFail = (state, action) => ({
  ...state,
  submitFormStatus: {
    loading: false,
    error: action.err
  }
});

const setAppointmentId = (state, action) => ({
  ...state,
  appointmentId: action.id
});
const setStockId = (state, action) => ({
  ...state,
  stockId: action.id
});

const fetchVendorsStart = (state, action) => ({
  ...state,
  vendorsDetail: { loading: true }
});
const fetchVendorsSuccess = (state, action) => ({
  ...state,
  vendorsDetail: { loading: false, vendors: action.data }
});
const fetchVendorsFail = (state, action) => ({
  ...state,
  vendorsDetail: { loading: false, vendors: [] }
});

const setStepFiveUrl = (state, action) => ({
  ...state,
  Url: action.data
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VEHICLE_ONBOARDING_STEPS:
      return setVehicleOnBoardingSteps(state, action);
    case actionTypes.VEHICLE_FORM_DATA_SET:
      return setVehicleFormData(state, action);
    case actionTypes.FETCH_VARIANTS_START:
      return fetchVariantsStart(state, action);
    case actionTypes.FETCH_VARIANTS_SUCCESS:
      return fetchVariantsSuccess(state, action);
    case actionTypes.FETCH_VARIANTS_FAIL:
      return fetchVariantsFail(state, action);
    case actionTypes.SET_AVAILABLE_FILTERS:
      return setAvailableFilters(state, action);
    case actionTypes.SET_CURRENT_FILTERS:
      return setCurrentFilter(state, action);
    case actionTypes.SET_SELECTED_VARIANT:
      return setSelectedVariant(state, action);
    case actionTypes.RESET_VEHICLE_FORM_DATA:
      return resetVehicleFormData(state, action);
    case actionTypes.GET_VEHICLE_DATA_START:
      return getVehicleDataStart(state, action);
    case actionTypes.GET_VEHICLE_DATA_SUCCESS:
      return getVehicleDataSuccess(state, action);
    case actionTypes.GET_VEHICLE_DATA_FAIL:
      return getVehicleDataFail(state, action);
    case actionTypes.SUBMIT_FORM_START:
      return submitFormStart(state, action);
    case actionTypes.SUBMIT_FORM_SUCCESS:
      return submitFormSuccess(state, action);
    case actionTypes.SUBMIT_FORM_FAIL:
      return submitFormFail(state, action);
    case actionTypes.SET_APPOINTMENTID:
      return setAppointmentId(state, action);
    case actionTypes.SET_STOCKID:
      return setStockId(state, action);
    case actionTypes.FETCH_VENDORS_START:
      return fetchVendorsStart(state, action);
    case actionTypes.FETCH_VENDORS_SUCCESS:
      return fetchVendorsSuccess(state, action);
    case actionTypes.FETCH_VENDORS_FAIL:
      return fetchVendorsFail(state, action);
    case actionTypes.SET_STEP_FIVE_URL:
      return setStepFiveUrl(state, action);
    default:
      return state;
  }
};

export default reducer;
